import { render } from "./RegisterApplication.vue?vue&type=template&id=06c5396e&scoped=true&lang=pug"
import script from "./RegisterApplication.vue?vue&type=script&lang=js"
export * from "./RegisterApplication.vue?vue&type=script&lang=js"

import "./RegisterApplication.vue?vue&type=style&index=0&id=06c5396e&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c5396e"]])

export default __exports__